module.exports = __webpack_public_path__ + "img/timeline_arrow.svg";